export type AppRole = 'admin' | 'client' | 'vendor';

export const APP_ROLES: AppRole[] = ['admin', 'client', 'vendor'];

export function isAppRole(value: unknown): value is AppRole {
  return value === 'admin' || value === 'client' || value === 'vendor';
}

export const ROLE_HOME: Record<AppRole, string> = {
  admin: '/admin-dashboard',
  client: '/client-dashboard',
  vendor: '/vendor-portal',
};

/** Routes that require authentication + an allowed role list. */
export const ROLE_ROUTES: Record<string, AppRole[]> = {
  '/admin-dashboard': ['admin'],
  '/admin-settings': ['admin'],
  '/vendor-portal': ['vendor', 'admin'],
  '/vendor-onboarding': ['vendor', 'admin'],
  '/client-dashboard': ['client', 'admin'],
  '/client-portal': ['client', 'admin'],
};

export const PROTECTED_ROUTE_PREFIXES = Object.keys(ROLE_ROUTES);
